import React from 'react';
import { FiX } from 'react-icons/fi';
import Modal from 'react-modal';

import {
  ModalDefaultWrapperContent,
  ModalDefaultWrapperHeader,
} from './styles';
import { Title } from '../titles';
import { LuX } from 'react-icons/lu';

Modal.setAppElement('#modal');

type ModalDefaultWrapperProps = {
  children: React.ReactNode;
  title?: string;
  isOpenModal: boolean;
  closeModal: () => void;
  className?: string | '';
  style?: React.CSSProperties | undefined;
};

export function ModalDefaultWrapper({
  children,
  title,
  closeModal,
  isOpenModal,
  className,
  style,
}: ModalDefaultWrapperProps) {
  return (
    <Modal
      className={className ? className : 'modal-default-wrapper'}
      overlayClassName="modal-default-wrapper-overlay"
      isOpen={isOpenModal}
      onRequestClose={(e) => {
        e.stopPropagation();
        closeModal();
      }}
      contentLabel="Example Modal"
      portalClassName="modal-default-wrapper-portal"
      shouldFocusAfterRender={false}
      style={{
        content: {
          zIndex: '99999',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: 'fit-content',
          width: 'fit-content',
          backgroundColor: '#fff',
          boxShadow: '0px 0px 6px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
          padding: '1rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          ...style,
        },
      }}
    >
      {title && (
        <ModalDefaultWrapperHeader hasTitle={!!title}>
          {title && <Title size="small">{title}</Title>}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              closeModal();
            }}
          >
            <FiX size={18} color="#3F3F3F" />
          </button>
        </ModalDefaultWrapperHeader>
      )}

      <ModalDefaultWrapperContent hasTitle={!!title}>
        {!title && (
          <div
            style={{
              position: 'absolute',
              top: '5px',
              right: '15px',
              zIndex: '9999',
            }}
          >
            <button
              style={{
                backgroundColor: 'inherit',
              }}
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}
            >
              <LuX size={20} color="#3F3F3F" />
            </button>
          </div>
        )}
        {children}
      </ModalDefaultWrapperContent>
    </Modal>
  );
}
